export const Unlock = () => {
  return (
    <svg
      width="70"
      height="70"
      viewBox="0 0 70 70"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="35" cy="35" r="35" fill="#F3F3F5" />
      <path
        d="M19 30.2363H12"
        stroke="#DDD3FF"
        strokeWidth="1.90909"
        strokeLinecap="round"
      />
      <path
        d="M22.1085 25.2361L19 22"
        stroke="#DDD3FF"
        strokeWidth="1.90909"
        strokeLinecap="round"
      />
      <path
        d="M22.1085 35.2363L18.1085 39.2363"
        stroke="#DDD3FF"
        strokeWidth="1.90909"
        strokeLinecap="round"
      />
      <path
        d="M26.8755 26.5377V27.2082H29.6691L29.7354 26.5377C29.7354 22.8555 32.731 19.8599 36.4132 19.8599H37.1609C40.8431 19.8599 43.8387 22.8555 43.8387 26.5377L43.905 35.2082H46.6982L46.6986 26.5377C46.6986 23.9902 45.7064 21.595 43.905 19.7936C42.1036 17.9922 39.7084 17 37.1609 17H36.4132C33.8656 17 31.4705 17.9922 29.6691 19.7936C27.8677 21.595 26.8755 23.9902 26.8755 26.5377Z"
        fill="#3A17AD"
      />
      <path
        d="M26.4205 32.446L45.9478 29.6713C46.7317 29.56 47.4587 30.106 47.5701 30.8899L49.715 45.9854C50.0683 48.4715 48.3366 50.7768 45.8506 51.13L32.4914 53.0283C30.0054 53.3815 27.7001 51.6498 27.3468 49.1638L25.2018 34.0679C25.0904 33.284 25.6365 32.557 26.4204 32.4456L26.4205 32.446Z"
        fill="#BBA7FF"
      />
      <path
        d="M38.958 37.56C38.86 36.87 37.9365 36.1996 36.9347 36.3419C35.9329 36.4843 35.2328 37.3854 35.3308 38.0754C35.3795 38.4182 35.6245 38.7003 35.9811 38.8799L36.6693 43.7234C36.739 44.2134 37.3722 44.5287 38.0836 44.4276C38.795 44.3265 39.3154 43.8473 39.2457 43.3573L38.5575 38.5138C38.8504 38.2419 39.0067 37.9028 38.958 37.56Z"
        fill="#3A17AD"
      />
    </svg>
  );
};
